import classNames from 'classnames/bind';
import React from 'react';

import Styles from './sectioncard.module.scss';

const cx = classNames.bind(Styles);

type Props = {
  children: React.ReactNode;
  className?: string;
};

const SectionCard = ({ children, className }: Props) => {
  return <section className={cx('section-card', className)}>{children}</section>;
};

export default SectionCard;
